import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress,
    Tooltip
} from "@mui/material";
import AppLayout from "../../components/AppLayout";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { useEditor, EditorContent } from "@tiptap/react";
import { sharedExtensions } from "../../components/TipTapViewer/extensions";
import { UpdateService } from "../../service/update_service";

function Atualizacoes() {
    const [loading, setLoading] = useState(true);
    const [atualizacoes, setAtualizacoes] = useState([]);
    const [atualizacaoSelecionada, setAtualizacaoSelecionada] = useState(null);
    const [modalAberto, setModalAberto] = useState(false);

    const editor = useEditor({
        extensions: sharedExtensions,
        content: "",
        editable: false,
    });

    useEffect(() => {
        const carregarAtualizacoes = async () => {
        try {
            setLoading(true);
            const updateService = new UpdateService();
            const dados = await updateService.fetchRecentsUser();
            setAtualizacoes(dados || []);
        } catch (error) {
            console.error("Erro ao carregar atualizações:", error);
        } finally {
            setLoading(false);
        }
    };
        carregarAtualizacoes();
    }, []);
    
    const formatarData = (dataString) => {
		const data = new Date(dataString);
		return data.toLocaleDateString("pt-BR", {
			day: "2-digit", month: "2-digit", year: "numeric",
			hour: "2-digit", minute: "2-digit"
		});
	};

    // Função para abrir o modal de visualização
	const handleVisualizar = (atualizacao) => {
		setAtualizacaoSelecionada(atualizacao);
		if (editor) {
			try {
				editor.commands.setContent(JSON.parse(atualizacao.descricao));
			} catch (e) {
				console.error("Erro ao ler conteúdo", e);
			}
		}
		setModalAberto(true);
	};

    return (
        <AppLayout currentPage="atualizacoes">
            <Box sx={{ maxWidth: 1400, mx: "auto" }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 3,
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                color: "#666",
                                fontWeight: 600,
                            }}
                        >
                            Atualizações recentes
                        </Typography>
                        
                    </Box>

                    {/* Tabela */}
                    <Paper
                        sx={{
                            bgcolor: "white",
                            borderRadius: "12px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                            overflow: "hidden",
                        }}
                    >
                        {loading ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: "400px",
                                }}
                            >
                                <CircularProgress sx={{ color: "#1a9e8f" }} />
                            </Box>
                        ) : atualizacoes.length === 0 ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: "400px",
                                    gap: 2,
                                    p: 4,
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{ color: "#999", textAlign: "center" }}
                                >
                                    Nenhuma atualização recente.
                                </Typography>
                               
                            </Box>
                        ) : (
                            <>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                                                <TableCell sx={{ fontWeight: 600, color: "#666" }}>
                                                    Data de publicação
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600, color: "#666" }}>
                                                    Título
                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600, color: "#666"}}>
                                                    Visualizar
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {atualizacoes.map((row) => (
                                                <TableRow
                                                    key={row.id}
                                                    sx={{
                                                        "&:hover": {
                                                            bgcolor: "#f9f9f9",
                                                        },
                                                    }}
                                                >
                                                    <TableCell>
                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                            {formatarData(row.createdAt)}
                                                        </Typography>
                                                        
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant="body2">
                                                            {row.titulo}
                                                        </Typography>
                                                    </TableCell>
                                                    
                                                    <TableCell align="center">
                                                        <Tooltip title="Visualizar Conteúdo">
													<IconButton onClick={() => handleVisualizar(row)} color="primary">
														<VisibilityIcon />
													</IconButton>
												</Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            <Dialog 
                                                open={modalAberto} 
                                                onClose={() => setModalAberto(false)}
                                                maxWidth="sm"
                                                fullWidth
                                                PaperProps={{
                                                    sx: { borderRadius: "12px" }
                                                }}
                                            >
                                                <DialogTitle sx={{ m: 0, p: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <Typography variant="h6" fontWeight="bold" color="#00a69a">
                                                        {atualizacaoSelecionada?.titulo}
                                                    </Typography>
                                                    <IconButton onClick={() => setModalAberto(false)}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </DialogTitle>
                                                <DialogContent dividers>
                                                    {atualizacaoSelecionada?.imagemUrl && (
                                                        <Box sx={{ mb: 3, textAlign: "center" }}>
                                                            <img 
                                                                src={atualizacaoSelecionada.imagemUrl} 
                                                                alt="Atualização" 
                                                                style={{ maxWidth: "100%", 
                                                                    borderRadius: "8px",
                                                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                                                                }} 
                                                            />
                                                        </Box>
                                                    )}
                                                    <Box className="tiptap-content" sx={{ color: "#444", fontSize: "15px" }}>
                                                        <EditorContent editor={editor} />
                                                    </Box>
                                                </DialogContent>
                                            </Dialog>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                        )}
                    </Paper>
            </Box>
        </AppLayout>
    );
}

export default Atualizacoes;
